import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormGroup, Label} from "reactstrap";
import {FormattedMessage} from "react-intl";
import Switch from "components/Switch";
import Select from "react-select";
import { connect } from 'react-redux';

class TabOpen extends PureComponent {

  constructor(props, context) {
    super(props, context);

    this.onChange = this.onChange.bind(this);
  }

  onChange(key, value) {
    let data = this.props.data.survey.questionSettings.open;
    data[key] = value;

    this.props.onChangeQuestionSettings('open', data);
  }

  render() {
    const {errors, data, questionConfig} = this.props;

    return (
      <React.Fragment>
        <FormGroup>
          <Label><FormattedMessage id="_.question.open.presentationType" /></Label>
          <Select
            isMulti
            value={_.map(data.survey.questionSettings.open.presentationTypes, type => {
              return {
                label: <FormattedMessage id={'_.question.open.presentationType.' + type} />,
                value: type,
              }
            })}
            onChange={e => {
              this.onChange('presentationTypes', e.map(val => val.value))
            }}
            options={_.map(questionConfig.presentationTypes, type => {
              return {
                label: <FormattedMessage id={'_.question.open.presentationType.' + type} />,
                value: type,
              }
            })}
          />
        </FormGroup>
        <FormGroup>
          <Label for="charsLengthMax"><FormattedMessage id="admin.planEdit.label.survey.questionSettings.charsLengthMax" /></Label>
          <Switch checked={data.survey.questionSettings.open.charsLengthMax} onChange={value => this.onChange('charsLengthMax', value)} />
        </FormGroup>
        <FormGroup>
          <Label for="charsLengthMax">Wysyłka wiadomości email po zakończeniu ankiety</Label>
          <Switch checked={data.survey.questionSettings.open.sendEmail} onChange={value => this.onChange('sendEmail', value)} />
        </FormGroup>
      </React.Fragment>
    );
  }
}


TabOpen.propTypes = {
  data: PropTypes.shape({
    survey: PropTypes.shape({
      questionSettings: PropTypes.shape({
        open: PropTypes.object.isRequired,
      }).isRequired
    }).isRequired,
  }),
  errors: PropTypes.object.isRequired,
  onChangeQuestionSettings: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    questionConfig: state.config.data.questions.open
  }
}

export default connect(mapStateToProps)(TabOpen);